"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBuilderFactory = void 0;
const ponder_1 = require("./apis/ponder");
const thegraph_1 = require("./apis/thegraph");
/**
 * Pure utility class to create query builders and transform data
 */
class QueryBuilderFactory {
    /**
     * Gets an API's query builder given an endpoint
     */
    static getQuery(endpoint) {
        if (!endpoint)
            return new thegraph_1.TheGraphQueryBuilder();
        // 1. Check for Ponder, thegraph for everything else as its our default
        if (endpoint.includes("up.railway.app"))
            return new ponder_1.PonderQueryBuilder();
        return new thegraph_1.TheGraphQueryBuilder();
    }
    /**
     * Ponder does not pluralize like the graph so `factory` becomes `factorys`, etc.
     */
    static getImpermaxFactory(input) {
        return input.data.impermaxFactories ? input.data.impermaxFactories[0] : input.data.impermaxFactorys[0];
    }
    /**
     * Helper to transform nested query results from various apis during apollo fetch.
     * Mainly used for Ponder as the graphql schema is different to thegraph due to pagination.
     */
    static transformData(input) {
        const transformValue = (value) => {
            if (!value)
                return value;
            if (Array.isArray(value))
                return value.map(transformValue);
            if (typeof value === "object") {
                const transformed = {};
                for (const [key, val] of Object.entries(value)) {
                    if (key === "items" && Array.isArray(val))
                        return val.map(transformValue);
                    transformed[key] = transformValue(val);
                }
                return transformed;
            }
            return value;
        };
        return Object.assign(Object.assign({}, input), { data: transformValue(input.data) });
    }
}
exports.QueryBuilderFactory = QueryBuilderFactory;
